export interface AttendanceSlot {
  label?: string;
  slotNumber: number;
  katildiMi: boolean;
  konumDisi: boolean;
  active?: boolean; // ✅ EKLEDİK
}

export interface Student {
  id: number;
  adSoyad: string;
  ogrenciNo: string;
  attendance: AttendanceSlot[];
  studentId: number;
}

export interface CourseState {
  courseId: number;
  courseStartId: number;
  haftalikDersId: number;
  akademikPersonelNo: number;
  teacherId: number;
  acilanDersDetayNo: number;
  acilanDersNo: number;
  dersBaslangic: Date | null;
  dersBitis: Date | null;
  started: boolean; // ❗ EKLENDİ
  gun: number;
  dersAd?: string;
  dersAdres?: string;
}

export interface AttendanceState {
  dersbasldimi: boolean;

  slotCount: number;
  aktifSlotIndex: number;

  totalSessionHours: number;

  attendanceDuration: number;

  yoklamaPeriyodu: 'saatbasi' | 'teksefer';

  yoklamaSuresi: number; // ❗ EKLENDİ

  students: Student[];

  slots: AttendanceSlot[];
}

export interface UiState {
  baslat: boolean;
  qrToken: string | null;
  qrBase64: string | null;

  qrUret: boolean;
  qrActive: boolean; // ✅ EK

  konumKontrol: boolean;
  konumUygun: boolean;

  search: string;

  timerStartedAt: number | null;
  timerDuration: number; // ✅ EK
  kalanSure: number;

  timerRunning: boolean; // ✅ EK

  modalOpen: boolean;

  qrExpireAt: number | null;

  currentStep: number;

  latitude: any;
  longitude: any;
  kampusLatitude?: number;
  kampusLongitude: number;
  binaLatitude: number;
  binaLongitude: number;
  loading: boolean;
  error: string | null;

  connection: boolean;

  attendanceHubConnected: boolean; // ✅ EK
  qrHubConnected: boolean; // ✅ EK

  coursePhase: 'idle' | 'running' | 'paused' | 'ended'; // ✅ EK
}

export interface AppState {
  course: CourseState;
  attendance: AttendanceState;
  ui: UiState;
}

export const initialState: AppState = {
  course: {
    courseId: 0,
    courseStartId: 0,
    haftalikDersId: 0,
    akademikPersonelNo: 0,
    dersBaslangic: null,
    dersBitis: null,
    started: false, // EK
    acilanDersDetayNo: 0,
    acilanDersNo: 0,
    teacherId: 0,
    gun: 0,
    dersAdres: '',
    dersAd: '',
  },

  attendance: {
    dersbasldimi: false,
    slotCount: 0,
    aktifSlotIndex: 0,
    totalSessionHours: 0,
    attendanceDuration: 60,
    yoklamaPeriyodu: 'saatbasi',
    students: [],
    slots: [],
    yoklamaSuresi: 0, // EK
  },

  ui: {
    baslat: false,
    qrToken: null,
    qrBase64: null,

    qrUret: false,
    qrActive: false,

    konumKontrol: false,
    konumUygun: false,

    search: '',

    timerStartedAt: null,
    timerDuration: 0,
    kalanSure: 0,

    timerRunning: false,

    modalOpen: false,

    qrExpireAt: null,

    currentStep: 1,

    loading: false,
    error: null,

    connection: false,

    attendanceHubConnected: false,
    qrHubConnected: false,
    latitude: 0,
    longitude: 0,
    kampusLatitude: 0,
    kampusLongitude: 0,
    binaLatitude: 0,
    binaLongitude: 0,
    coursePhase: 'idle',
  },
};
